<section class="card shadow-sm-darker">
  <div class="card-body">
    <h3>{{assessment.name}}</h3>
    <p class="text-sm mb-0"><span>{{timedType}} / {{questionType}}</span><br>
      <span><span class="font-weight-600">Start:</span> {{startTime}}</span><br>
      <span><span class="font-weight-600">Due:</span> {{endTime}}</span><br>
      <span *ngIf="assessment.optional" class="badge badge-lg badge-info">Optional</span>
      <span *ngIf="assessment.quizAssessment" class="badge badge-lg badge-info ml-2">Quiz Assessment</span>
    </p>
  </div>
</section>
<div class="card shadow-sm-darker mb-0">
  <div class="card-header">
    <div *ngIf="!fetching">
      <button *ngIf="!confirmAssessmentdelete" class="btn" (click)="openAddQuestion()">
        <i class="fa fa-plus"></i> Add Question
      </button>
    </div>
    <p *ngIf="loading" class="alert alert-neutral text-center mt-2 mb-0">{{loading}}</p>
    <p *ngIf="errormessage" class="alert alert-danger text-center mt-2 mb-0">{{errormessage}}</p>
  </div>
  <div class="card-body questionList">
    <p *ngIf="questions.length < 1" class="text-sm text-center font-italic mb-0">There Are No Questions Available</p>
    <ul class="list-group list-group-flush">
      <li class="list-group-item px-0" *ngFor="let question of questions; let optionGroupIndex = index ">
        <h4 class="text-xs mb-3"><span class="text-primary-darker">QUESTION {{optionGroupIndex + 1}}</span>
          ({{question.marks}} mark{{question.marks === 1 ? '' : 's'}})</h4>
        <div class="inlineOptions innerHTML-wrap mb-3" [innerHTML]="question.text | nl2br | customhtmlsanitizer">
        </div>
        <section *ngIf="question.type == 'MultipleChoice'">
          <h5>Options</h5>
          <ul class="list-group-disc text-sm">
            <li *ngFor="let option of question.options" class="mb-1"
              [ngClass]="{'text-primary-darker font-weight-600': option.isAnswer}">
              <span [innerHTML]="option.text | nl2br | customhtmlsanitizer" class="ml-2"></span>
            </li>
          </ul>
        </section>
        <section *ngIf="question.type == 'ShortText'">
          <h5>Answers</h5>
          <ul class="list-group-disc text-sm text-primary-darker font-weight-600">
            <li class="mb-1"><span class="ml-2">{{question.answer}}</span></li>
            <li class="mb-1"><span class="ml-2">{{question.altanswer}}</span></li>
          </ul>
        </section>
        <div class="mainbtn">
          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button class="question-action-btn bg-white" (click)="reorder(question.id, 1)"
              *ngIf="(optionGroupIndex + 1) != questions.length" title="Move Down"><i
                class="fa fa-arrow-down"></i></button>
            <button class="question-action-btn bg-white" (click)="reorder(question.id, -1)"
              *ngIf="optionGroupIndex != 0" title="Move Up"><i class="fa fa-arrow-up"></i></button>
            <button class="question-action-btn bg-white" routerLink="/user/addquestion"
              [queryParams]="{aid : this.assessmentID,classid:this.classID, actiontype : 200 , qid : question.id, batchid: this.batchID }"
              title="Edit"><i class="fa fa-edit"></i></button>
            <button class="deleteQuestion question-action-btn bg-white text-danger" title="Delete"><i
                class="fa fa-trash-alt"></i></button>
          </div>
        </div>
        <div class="confirmPane mt-3" style="display: none;">
          <p class="alert text-center deleteConfirmText">Are you sure you want to delete this question?</p>
          <div class="d-flex justify-content-around flex-wrap gap-.3">
            <button type="button" (click)="deleteQuestion(question.id)"
              class="btn btn--danger btn--sm text-xs m-0">Yes</button>
            <button type="button" class="undodelete btn btn--sm text-xs m-0">No</button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>

<div class="modal fade" id="deleteCourse" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Assessment</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this assessment?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" data-dismiss="modal"
            (click)="confirmDelete()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="uploadbatchquestion" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Upload Questions</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #uploadform="ngForm" name="uploadform" (ngSubmit)="uploadquestions(files.files,fileenccoding.value,format.value,negmarking.checked,raw.checked)">
          <div class="fieldset fieldset--lg">
            <p class="text-center text-sm">{{classFileName || 'No File Selected'}}</p>
            <button (click)="files.click()" type="button" id="filesLabel" class="btn m-auto">Select
              File</button>
            <input #files (change)="classFileName = files.files[0]?.name" type="file" name="files"
              accept=".xls,.xlsx,.xml,.txt" aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
          </div>
          <div class="fieldset fieldset--lg">
            <label for="fileenccoding" class="legend">File Encoding <span class="requiredfield">*</span></label>
            <select class="text-field" ngModel name="fileenccoding" id="fileenccoding" #fileenccoding required>
              <option selected value="Default"> Default </option>
              <option value="UTF-8">UTF-8 </option>
            </select>
          </div>
          <div class="fieldset fieldset--lg">
            <label for="format" class="legend">Question Format <span class="requiredfield">*</span></label>
            <select class="text-field" ngModel name="format" id="format" #format required>
              <option [selected]="true" value="Format1"> Format 1 </option>
              <option value="Format2">Format 2</option>
            </select>
          </div>
          <div class="fieldset fieldset--lg flex-row align-items-center">
            <label for="negmarking" class="mb-0 text-sm">Enable Negative Marking</label>
            <input type="checkbox" id="negmarking" ngModel name="negmarking" #negmarking class="ml-2">
          </div>
          <div class="fieldset fieldset--lg flex-row align-items-center">
            <label for="raw" class="mb-0 text-sm">Use Raw HTML</label>
            <input type="checkbox" id="raw" ngModel name="raw" #raw class="ml-2">
          </div>
          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button type="submit" class="btn m-0"
              [disabled]="uploadform.invalid || files.files.length < 1">
              Upload
            </button>
            <button type="button" data-dismiss="modal" class="btn btn--warning m-0">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
